/* eslint-disable no-restricted-properties -- This module is the allowlisted runtime env boundary. */
/** Public allowlist only. Dynamic env lookup prevents Next build-time substitution. */
export const PUBLIC_RUNTIME_KEYS = [
  "NEXT_PUBLIC_APP_URL", "NEXT_PUBLIC_ACCOUNTS_URL", "NEXT_PUBLIC_VENDORS_URL",
  "NEXT_PUBLIC_API_URL", "NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY",
] as const;
export type PublicRuntimeKey = typeof PUBLIC_RUNTIME_KEYS[number];
export type PublicRuntimeConfig = Partial<Record<PublicRuntimeKey, string>>;
declare global { interface Window { __SG_PUBLIC_CONFIG?: PublicRuntimeConfig } }
export function publicRuntimeValue(key: PublicRuntimeKey): string | undefined {
  if (typeof window !== "undefined" && window.__SG_PUBLIC_CONFIG) return window.__SG_PUBLIC_CONFIG[key];
  return process.env[key];
}
export function publicRuntimeConfig(): PublicRuntimeConfig {
  return Object.fromEntries(PUBLIC_RUNTIME_KEYS.map(key => [key, process.env[key] ?? ""]));
}
export function publicRuntimeScript(config: PublicRuntimeConfig): string {
  // The allowlist also applies when called with an object containing other keys.
  const allowed = Object.fromEntries(PUBLIC_RUNTIME_KEYS.map(key => [key, config[key] ?? ""]));
  return `window.__SG_PUBLIC_CONFIG=${JSON.stringify(allowed).replace(/</g, "\\u003c").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029")};`;
}
